import React from "react";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
            I'm a Frontend Developer
          </h2>
          <p className="text-gray-500 py-4 max-w-md">
          As an aspiring frontend developer, I am currently learning and building skills in HTML, CSS, JavaScript, and React. Recently, I completed an internship in data science, where I gained practical experience in data analysis and visualization. With a passion for creating user-friendly web applications, I am eager to apply my knowledge and grow in web development. My next goal is to master backend technologies to become a full-stack developer.
          </p>

          
        </div>

      </div>
    </div>
  );
};

export default Home;
